// extracted by mini-css-extract-plugin
export default {"dataProcessing":"HabeasData_dataProcessing__mi5Lj","habeasDataIcon":"HabeasData_habeasDataIcon__8lTnW"};